import api from "../api";

// Posts
export const createTribePost = async (tribeId, data) => {
  return await api.getApi().post(`/tribes/${tribeId}/posts`, data);
};

export const getTribePosts = async (tribeId, page = 1, limit = 20) => {
  return await api.getApi().get(`/tribes/${tribeId}/posts`, {
    params: { page, limit },
  });
};

export const getTribePost = async (tribeId, postId) => {
  return await api.getApi().get(`/tribes/${tribeId}/posts/${postId}`);
};

export const updateTribePost = async (tribeId, postId, data) => {
  return await api.getApi().put(`/tribes/${tribeId}/posts/${postId}`, data);
};

export const deleteTribePost = async (tribeId, postId) => {
  return await api.getApi().delete(`/tribes/${tribeId}/posts/${postId}`);
};

// Comments
export const addComment = async (tribeId, postId, data) => {
  return await api.getApi().post(`/tribes/${tribeId}/posts/${postId}/comments`, data);
};

export const deleteComment = async (tribeId, postId, commentId) => {
  return await api.getApi().delete(`/tribes/${tribeId}/posts/${postId}/comments/${commentId}`);
};

// Reactions
export const addReaction = async (tribeId, postId, emoji) => {
  return await api.getApi().post(`/tribes/${tribeId}/posts/${postId}/reactions`, { emoji });
};

export const removeReaction = async (tribeId, postId, emoji) => {
  return await api.getApi().delete(`/tribes/${tribeId}/posts/${postId}/reactions`, { data: { emoji } });
};
